import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import logo from "../../static/media/logo_menu.png";
import NavbarMobile from "./NavbarMobile";
import "../Navbar.css";

const pages = [
  { name: "INICIO", path: "/" },
  { name: "SERVICIOS", path: "/servicios" },
  { name: "CLUB HYDROLUZ", path: "/club-hydroluz" },
  { name: "TIENDA", path: "/categorias" },
  { name: "OFERTAS", path: "/ofertas" },
  { name: "CONTACTOS", path: "/contactos" },
];

export default function NavbarScroll() {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "center", pt: "1rem" }}>
      <AppBar
        position="fixed"
        sx={{
          top: 0,
          left: "50%",
          transform: "translateX(-50%)",
          width: "90%",
          borderRadius: 4,
          background: "#E6F0FA",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          zIndex: 1200,
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: { xs: 2, md: 6 },
            py: 1,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <img
              src={logo}
              alt="Hydroluz"
              style={{ height: "45px" }}
            />
          </Box>

          {!isMobile && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 2,
              }}
            >
              {pages.map((page) => (
                <Typography
                  key={page.name}
                  className={`nav-btn-h ${isActive(page.path) ? "active" : ""}`}
                  onClick={() => navigate(page.path)}
                  style={{ cursor: "pointer" }}
                >
                  {page.name}
                </Typography>
              ))}
            </Box>
          )}

          {isMobile && (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <NavbarMobile
                cartCount={0}
                showLogged={false}
                isActive={isActive}
                navigate={navigate}
                onLogin={() => {}}
                onLogout={() => {}}
                onAccount={() => {}}
              />
            </Box>
          )}
        </Toolbar>
      </AppBar>
    </Box>
  );
}
